<template>
  <div class="from-panel" ref="panel">
    <div class="from-title">
      <div class="colorBut">
        <el-button class="line-button" plain icon="el-icon-plus" @click="newProcess(null)">审批流列表</el-button>
        <el-button icon="el-icon-plus" @click="addGroup">新建分组</el-button>
        <div class="widthInput">
          <el-select clearable v-model="groupId" filterable placeholder="请选择" @change="searchGroup">
            <el-option v-for="item in groupall" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="widthInput">
          <el-input
            clearable
            placeholder="表单名称"
            prefix-icon="el-icon-search"
            @input="searchItem"
            v-model="templateName"
          ></el-input>
        </div>
      </div>
    </div>
    <draggable
      :list="groups"
      group="group"
      handle=".el-icon-rank"
      filter=".undrag"
      @start="groupsSort = true"
      :options="{animation: 300 ,sort:true, scroll: true, chosenClass:'choose'}"
      @end="groupSort"
    >
      <div
        :class="{'form-group':true, 'undrag': (group.id === 0 || group.id === undefined)}"
        v-for="(group, gidx) in groups"
        :key="gidx"
      >
        <div class="form-group-title">
          <span>{{group.name}}</span>
          <i class="el-icon-rank" title="长按拖动可对分组排序"></i>
          <div class="center">
            <i @click="showDomChange(gidx)" class="el-icon-caret-right" v-show="!group.showDom"></i>
            <span @click="showDomChange(gidx)" class="span" v-if="!group.showDom">展开</span>
            <i @click="showDomChange(gidx)" class="el-icon-caret-bottom" v-show="group.showDom"></i>
            <span @click="showDomChange(gidx)" class="span" v-if="group.showDom">收起</span>
          </div>

          <div v-if="!(group.id === 0 || group.id === undefined)">
            <el-dropdown>
              <el-button type="text" icon="el-icon-setting">编辑分组</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-edit-outline" @click.native="editGroup(group)">修改名称</el-dropdown-item>
                <el-dropdown-item
                  icon="el-icon-delete"
                  class="delete-btn"
                  @click.native="delGroup(group)"
                >删除分组</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <draggable
          style="width: 100%; min-height:25px"
          :list="group.templateRespList"
          group="from"
          @end="groupSort"
          filter=".undrag"
          :options="{animation: 300, delay: 200, chosenClass:'choose', scroll: true, sort:true}"
        >
          <div v-show="groups[gidx].showDom">
            <div
              :class="{'form-group-item':true, 'undrag': item.isStop}"
              v-for="(item, index) in group.templateRespList"
              :key="index"
            >
              <div class="itemrow">
                <div class="img"></div>
                <span>{{item.name}}</span>
                <br />
              </div>
              <div class="itemrow" :title="item.projectName || item.deptName">
                <span>{{item.projectName || item.deptName}}</span>
              </div>
              <div class="itemrow">{{item.remark}}</div>
              <div class="itemrow">
                <span>最后更新时间：{{ item.updateTime ? item.updateTime.substring(0, 16) : item.createTime.substring(0, 16) }}</span>
              </div>

              <div>
                <el-button
                  type="text"
                  icon="el-icon-edit-outline"
                  size="mini"
                  @click="editFrom(item, group)"
                >修改</el-button>
                <el-button
                  type="text"
                  icon="el-icon-close"
                  class="delete-btn"
                  size="mini"
                  @click="stopFrom(item)"
                >{{'删除'}}</el-button>

                <el-button
                  type="text"
                  class="delete-btn"
                  icon="el-icon-delete"
                  size="mini"
                  @click="moveFrom(item)"
                  v-if="item.isStop"
                >删除</el-button>
                <el-popover
                  placement="left"
                  trigger="click"
                  width="400"
                  style="margin-left: 10px"
                  @show="moveSelect === null"
                  v-else
                >
                  <!-- v-show="g.id > 1" -->
                  <el-radio-group v-model="moveSelect" size="mini">
                    <el-radio
                      :label="g.id"
                      border
                      v-for="g in groups"
                      :key="g.id"
                      :disabled="g.id === group.id"
                      style="margin: 10px;"
                    >{{g.name}}</el-radio>
                  </el-radio-group>
                  <div style="text-align: right; margin: 0">
                    <el-button type="primary" size="mini" @click="moveFrom(item)">提交</el-button>
                  </div>
                  <el-button slot="reference" type="text" icon="el-icon-s-promotion" size="mini">移动</el-button>
                </el-popover>
              </div>
            </div>
          </div>
        </draggable>
        <div
          style="text-align: center"
          v-if="group.items === undefined || group.items.length === 0"
        >
          <el-button
            style="padding-top: 0"
            type="text"
            icon="el-icon-plus"
            @click="newProcess(group.id)"
          >创建新表单</el-button>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import {
  getFormGroups,
  groupItemsSort,
  addgroup,
  updateGroup,
  deleteBatch,
  updateForm,
  deletetemplate,
  groupallList,
} from '@/api/design'

export default {
  name: 'FormsPanel',
  components: { draggable },
  data() {
    return {
      moveSelect: '',
      templateName: '',
      visible: false,
      groupsSort: false,
      groups: [],
      groupall: [],
      groupId: '',
    }
  },
  mounted() {
    this.getGroups()
    this.groupallList()
  },
  created() {
    // let params = window.location.href.split('?')
    // console.log(params, 'params---------------------------')

    var url = decodeURI(window.location.search)
    var object = {}
    if (url.indexOf('?') != -1) {
      var str = decodeURIComponent(url.substr(1)) //得到?后面的字符串
      var strs = str.split('&') //将得到的参数分隔成数组[id="123456",name="www"];
      for (var i = 0; i < strs.length; i++) {
        object[strs[i].split('=')[0]] = strs[i].split('=')[1] //得到{id:'123456',name:'www'}
      }
    }
    console.log(object, 'object-------------------------')

    sessionStorage.setItem('webParmars', JSON.stringify(object))
  },
  methods: {
    searchItem() {
      this.getGroups({ groupId: this.groupId, templateName: this.templateName })
    },
    searchGroup() {
      this.getGroups({ groupId: this.groupId, templateName: this.templateName })
    },
    showDomChange(i) {
      this.groups[i].showDom = !this.groups[i].showDom
      this.$set(this.groups, i, {
        ...this.groups[i],
        showDom: this.groups[i].showDom,
      })
      console.log(this.groups)
    },
    getGroups(val) {
      getFormGroups(val)
        .then((res) => {
          this.groups = res.data.data
          this.groups.forEach((d) => {
            d.showDom = true
          })
        })
        .catch((err) => this.$message.error('获取分组异常'))
    },
    groupallList(val) {
      groupallList(val)
        .then((res) => {
          this.groupall = res.data.data
        })
        .catch((err) => this.$message.error('获取分组异常'))
    },
    newProcess(groupId) {
      console.log(groupId, 'groupId---------------------------')
      this.$store.commit('setTemplate', this.getTemplateData())
      this.$store.commit('setIsEdit', false)
      if (groupId) {
        this.$router.push('/admin/design?groupId=' + groupId)
      } else {
        this.$router.push('/admin/design')
      }
    },
    groupSort() {
      this.groupsSort = false
      groupItemsSort(this.groups)
        .then((rsp) => {
          this.$message.success(rsp.data)
          this.getGroups()
        })
        .catch((err) => {
          this.getGroups()
          this.$message.error(err.response.data)
        })
    },
    addGroup() {
      this.$prompt('请输入要添加的组名', '新的分组名', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        inputPattern: /^[\u4E00-\u9FA5A-Za-z0-9\\-]{1,30}$/,
        inputErrorMessage: '分组名不能为空且长度小于30',
        inputPlaceholder: '请输入分组名',
      }).then(({ value }) => {
        addgroup({ name: value }, 'post')
          .then((rsp) => {
            this.$message.success(rsp.data)
            this.getGroups()
          })
          .catch((err) => this.$message.error(err.response.data))
      })
    },
    delGroup(group) {
      this.$confirm(
        '删除分组并不会删除表单，表单将会被转移到 “其他” 分组，确定要删除分组 ' +
          group.name +
          '?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        deleteBatch(group.id)
          .then((rsp) => {
            this.$message.success(rsp.data)
            this.getGroups()
          })
          .catch((err) => this.$message.error(err.response.data))
      })
    },
    editGroup(group) {
      this.$prompt('请输入新的组名', '修改分组名', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        inputPattern: /^[\u4E00-\u9FA5A-Za-z0-9\\-]{1,30}$/,
        inputErrorMessage: '分组名不能为空且长度小于30',
        inputPlaceholder: '请输入分组名',
        inputValue: group.name,
      }).then(({ value }) => {
        updateGroup({ id: group.id, name: value })
          .then((rsp) => {
            this.$message.success(rsp.data)
            this.getGroups()
          })
          .catch((err) => this.$message.error(err.response.data))
      })
    },
    updateForm(item, type) {
      updateForm({ templateId: item.templateId, type: type })
        .then((rsp) => {
          this.$message.success(rsp.data)
          this.getGroups()
        })
        .catch((err) => this.$message.error(err.response.data))
    },
    getTemplateData(data, group) {
      return data
    },
    editFrom(item, group) {
      this.$router.push('/admin/design?code=' + item.id)
    },
    stopFrom(item) {
      console.log(item)
      let tip = '删除模板'
      this.$confirm(
        `<span style="font-weight: bold">${item.menuName}</span>` + tip,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        deletetemplate(item.id).then((res) => {
          this.getGroups()
        })
      })
    },
    moveFrom(item) {
      if (item.isStop) {
        this.$confirm(
          `您确定要删除表单 <span style="font-weight: bold">${item.formName}</span>> 吗，删除后无法恢复，是否继续？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true,
          }
        ).then(() => {
          this.updateForm(item, 'delete')
        })
      } else {
        if (this.moveSelect === null || this.moveSelect === '') {
          this.$message.error('请选择分组')
          return
        }
        updateForm({
          templateId: item.templateId,
          type: 'move',
          groupId: this.moveSelect,
        })
          .then((rsp) => {
            this.$message.success(rsp.data)
            this.getGroups()
            this.moveSelect = null
          })
          .catch((err) => this.$message.error(err.response.data))
      }
    },
  },
}
</script>

<style lang="less" scoped>
.widthInput {
  width: 200px;
  margin-left: 15px;
}
.itemrow {
  width: 20%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.img {
  width: 26px;
  height: 26px;
  margin-top: 5px;
  background-image: url('https://apintel.oss-cn-shenzhen.aliyuncs.com/admin-api/1702352462531Frameconcat.png');
  background-size: 100% 100%;
  display: inline-block;
  margin-right: 6px;
}
/deep/ .colorBut {
  display: flex;
  .el-button:hover,
  .el-button:focus {
    background: #ffffff;
    border-color: #2f4cdd;
    // color: #2f4c;
    color: #2f4cdd;
  }
}
/deep/ .el-button--text {
  color: #2f4cdd;
}
.delete-btn {
  color: #f56c6c;
}
body {
  background: #ffffff !important;
}

.undrag {
  background: #ebecee !important;
}
.line-button {
  background-color: #2f4cdd;
  color: #ffffff;
  border-color: #2f4cdd;
  margin-left: 0 !important;
}

.from-panel {
  padding: 20px 20px;
  min-width: 500px;
  background: #ffffff;

  /deep/ .el-input .el-input__inner {
    border-radius: 8px;
  }

  /deep/ .from-title {
    div {
      // float: right;

      .el-button {
        border-radius: 15px;
      }
    }
  }

  //height: 100vh;
}

.choose {
  background: #e9ebee;
}

.form-group {
  margin: 20px 0;
  padding: 5px 0px;
  border-radius: 10px;
  //border: 1px solid #d3d3d3;
  box-shadow: 1px 1px 10px 0 #d2d2d2;

  &:hover {
    box-shadow: 1px 1px 12px 0 #b3b3b3;
  }

  .form-group-title {
    padding: 5px 20px;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #d3d3d3;
    .center {
      position: absolute;
      left: 50%;
      cursor: pointer;
      .span {
        font-size: 14px;
        color: #3e3e3e;
      }
    }
    .el-icon-rank {
      display: none;
      cursor: move;
    }

    &:hover {
      .el-icon-rank {
        display: inline-block;
      }
    }

    div {
      display: inline-block;
      float: right;
    }

    span:first-child {
      margin-right: 5px;
      font-size: 18px;
      font-weight: bold;
    }

    span:nth-child(2) {
      color: #656565;
      font-size: small;
      margin-right: 10px;
    }

    /deep/ .el-button {
      color: #404040;
      margin-left: 20px;

      &:hover {
        color: #2b2b2b;
      }
    }
  }

  .form-group-item:nth-child(1) {
    border-top: none !important;
  }

  .form-group-item {
    color: #3e3e3e;
    font-size: small;
    padding: 2px 0;
    margin: 0 20px;
    height: 40px;
    position: relative;
    line-height: 40px;
    border-top: 1px solid #d3d3d3;

    div {
      display: inline-block;
    }

    i {
      border-radius: 10px;
      padding: 7px;
      font-size: 20px;
      color: #ffffff;
      margin-right: 10px;
    }

    div:nth-child(1) {
      float: left;
      margin-right: 20px;
    }

    div:nth-child(2) {
      // width: 150px;
      margin-right: 20px;
    }

    div:nth-child(3) {
      // width: 150px;
      margin-right: 20px;
    }
    div:nth-child(4) {
      // width: 600px;
      margin-right: 20px;
    }
    div:nth-child(5) {
      position: absolute;
      right: 20px;
    }

    // div:nth-child(4) {
    //   float: right;
    // }
  }
}

// @media screen and (max-width: 1000px) {
//   .desp {
//     display: none !important;
//   }
// }

// @media screen and (max-width: 800px) {
//   .from-panel {
//     padding: 50px 10px;
//   }
// }
</style>
